import axios from 'axios'
import ensureBasePath from './ensureBasePath'
import config from '../config'

export const greenhouseApiClient = axios.create({
  baseURL: 'https://boards-api.greenhouse.io/',
})

export const geolocationApiClient = axios.create({
  baseURL: 'https://api.geocode.earth/',
})

const apiClient = axios.create({
  baseURL: typeof window !== 'undefined' ? ensureBasePath(`/api`) : config.apiHost,
})

apiClient.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

export default apiClient
